@if (activeSlide == slides.loading) {
<div class="flex flex-col items-center justify-center p-4 h-full w-full">
  <div class="rounded-3xl" sxWidth="full" sxBackground="light" sxCol sxAlign="center" sxGap="10px" sxPadding="medium"
    sxBorderColor="one" sxBorderWidth="1px">


    <p class="mt-4 mb-2 text-zinc-400">Checking login status...</p>
    <div>
      <ion-skeleton-text animated class="size-[100px] rounded-full"></ion-skeleton-text>
    </div>
    <ion-skeleton-text animated class="w-[200px] mx-auto my-4 h-6 rounded-md"></ion-skeleton-text>


    <ion-skeleton-text animated class="w-full h-[60px] rounded-lg"></ion-skeleton-text>



  </div>
</div>
}
@if (activeSlide == slides.loggedIn) {
<div sxWidth="full" sxHeight="full" sxPadding="medium" sxCol sxGap="10px" sxAlign="stretch" sxDistribution="center">

  @let user = authenticatedUser$ | async;
  <!-- @let user = null; -->

  <div sxCol sxGap="10px" sxAlign="center" sxWidth="full">

    <div class="rounded-3xl" sxWidth="full" sxBackground="light" sxCol sxAlign="center" sxGap="10px" sxPadding="medium"
      sxBorderColor="one" sxBorderWidth="1px">


      @if (user) {
      <p class="mt-4 mb-2 text-zinc-400">You're logged in as</p>
      <avatar-round [title]="user?.name" [imageUrl]="user.displayPictureUrl"></avatar-round>
      <div class="name-container">
        <display-name textAlign="center" textSize="26px" iconSize="28px"></display-name>
      </div>
      @if (user?.email) {
      <p class="w-full text-center m-0 text-base text-gray-500">{{user.email}}</p>
      }
      <super-button sxWidth="full" sxMargin="10px 0 10px" [action]="onContinueAsLoggedInUserClicked"
        iconEnd="chevron-forward-outline">
        Continue
      </super-button>
      @if (user && canShowLogoutOption) {
      <super-button class="mb-2 w-full" iconEnd="arrow-back-outline" (click)="useOtherAccount()" type="outline">
        Logout
      </super-button>
      }
      }
      @else {
      <p class="mt-4 mb-2 text-zinc-400">Checking login status...</p>
      <div>
        <ion-skeleton-text animated class="size-[100px] rounded-full"></ion-skeleton-text>
      </div>
      <ion-skeleton-text animated class="w-[200px] mx-auto my-4 h-6 rounded-md"></ion-skeleton-text>


      <ion-skeleton-text animated class="w-full h-[60px] rounded-lg"></ion-skeleton-text>

      }

    </div>



  </div>


</div>
}

@if (activeSlide == slides.defaultCredential) {
<div sxWidth="full" sxHeight="full" sxPadding="medium" sxCol sxGap="10px" sxAlign="stretch" sxDistribution="center">

  @if (defaultCredentialUser) {
  <div sxCol sxGap="10px" sxAlign="center">

    <avatar-round [title]="defaultCredentialUser?.name"
      [imageUrl]="defaultCredentialUser.displayPictureUrl"></avatar-round>

    <p>Send OTP</p>
    <super-button sxWidth="full" [action]="onEmail" iconEnd="chevron-forward-outline">
      {{ "Continue as " + defaultCredentialUser.name }}
    </super-button>
  </div>
  }

</div>
}

@if (activeSlide == slides.signIn) {
<div sxCol sxGap="10px" sxWidth="fill" sxHeight="full" sxAlign="stretch" sxPadding="medium">
  @if (!isSubmittingSignIn) {

  @if (lockContacts) {
  <div
    class="locked-verify-card mx-auto mt-2 w-full max-w-md rounded-3xl border border-slate-200/80 bg-white p-5 shadow-sm">
    <div class="mb-6">
      <ion-icon [name]="isLoginWithEmail ? 'mail-outline' : 'call-outline'"
        class="m-0 block text-[28px] leading-none text-slate-400" aria-hidden="true"></ion-icon>
      <p class="m-0 mt-2 text-[22px] font-semibold leading-7 text-slate-800">
        Verify your {{isLoginWithEmail ? 'email' : 'phone'}}
      </p>
      <p class="m-0 mt-2 text-base leading-6 text-slate-600">
        We&apos;ll send a 4-digit verification code to <br />
        <span class="text-slate-800 font-semibold">{{lockedFlowContactLabel || 'your registered contact'}}</span>
      </p>
    </div>
    <super-button class="w-full" [action]="onSendCode" iconEnd="chevron-forward-outline" [showError]="true">
      Send code
    </super-button>
  </div>
  }
  @else {

  @if (!isLoginWithEmail) {
  <div sxGap="10px" sxCol>

    @if (existingAccountFoundAgainst == 'email' && existingAccount.phoneNumber) {
    <div sxRadius="small" sxGap="10px" sxBackground="base-shade" sxPadding="medium" sxRow sxAlign="center"
      sxDistribution="spaceBetween">
      <p sxMargin="0" sxTextSize="small">To continue as {{existingAccount.name}}, enter the full phone
        number: {{existingAccount.phoneNumber}} below.</p>
      <ion-icon sxTextSize="32px" sxCursor="pointer" (click)="existingAccountFoundAgainst = null"
        name="close-circle-outline"></ion-icon>
    </div>
    }
    <super-input type="phone" placeholder="Enter Phone Number" [(value)]="createUserDto.phoneVerifier.receiverId"
      [readonly]="lockContacts && !!defaultPhone" [countryCode]="'+91'" [showCountrySelector]="true"></super-input>

    <super-button [action]="onContinueWithPhone" [showError]="true" iconEnd="chevron-forward-outline">Continue with
      Phone
    </super-button>
  </div>
  }

  @if (isLoginWithEmail) {
  <div sxGap="10px" sxCol>
    @if (existingAccountFoundAgainst == 'phone' && existingAccount.email) {
    <div sxRadius="small" sxGap="10px" sxBackground="base-shade" sxPadding="medium" sxRow sxAlign="center"
      sxDistribution="spaceBetween">
      <p sxMargin="0" sxTextSize="small">To continue as {{existingAccount.name}}, enter the full
        email: {{existingAccount.email}} below.</p>
      <ion-icon sxTextSize="32px" sxCursor="pointer" (click)="existingAccountFoundAgainst = null"
        name="close-circle-outline"></ion-icon>
    </div>
    }
    <super-input [(value)]="createUserDto.emailVerifier.receiverId" iconStart="mail-outline"
      placeholder="Enter your Email" type="email" [readonly]="lockContacts && !!defaultEmail"></super-input>
    <super-button [action]="onContinueWithEmail" iconEnd="chevron-forward-outline" [showError]="true">Continue with
      Email
    </super-button>
  </div>
  }


  @if (showAuthChannelSwitchRow) {
  <div class="or-label">
    <p>OR</p>
  </div>
  }
  @if (showSwitchToEmail) {
  <super-button iconStart="mail-outline" background="light" color="dark" (click)="switchToContinueWithEmail()"
    textAlign="start">
    Continue with Email
  </super-button>
  }
  @if (showSwitchToPhone) {
  <super-button iconStart="call-outline" background="light" color="dark" (click)="switchToContinueWithPhone()"
    textAlign="start">
    Continue with Phone
  </super-button>
  }


  <div id="verifier"></div>
  <p class="terms-label">
    By continuing, you agree to our
    <a href="https://oneqid.com/privacy-policy/">Privacy policy</a> &
    <a href="https://oneqid.com/terms-of-use/">Terms of Use</a>
  </p>
  }
  }


</div>
}

@if (activeSlide === slides.setupIncomplete) {
<div sxCol sxGap="16px" sxPadding="medium" sxAlign="stretch">
  <p class="m-0 text-lg font-semibold text-zinc-800">Account not found</p>
  <p class="m-0 text-sm text-zinc-600">
    Please finish setting up your business in Business Suite, then sign in here again.
  </p>
  <super-button sxWidth="full" [action]="openBusinessSuiteSetup" iconEnd="chevron-forward-outline">
    Continue
  </super-button>
  <super-button sxWidth="full" type="outline" (click)="goBackFromSetupIncomplete()" iconEnd="arrow-back-outline">
    Back
  </super-button>
</div>
}


<!--User Name Slide-->
@if (activeSlide === slides.signUp) {
<div sxCol sxGap="10px" sxPadding="medium">

  <super-input [(value)]="createUserDto.name" placeholder="Full Name" iconStart="person-outline" [required]="true"
    [readonly]="lockContacts && !!defaultName" label="Full Name"></super-input>
  <super-input [readonly]="(createUserDto.emailVerifier.otpId != null) || (lockContacts && !!defaultEmail)"
    [required]="isEmailRequired" [(value)]="createUserDto.emailVerifier.receiverId" [validate]="true"
    placeholder="Email" label="Email" type="email" iconStart="mail-outline"></super-input>

  <super-input [readonly]="(createUserDto.phoneVerifier.otpId != null) || (lockContacts && !!defaultPhone)"
    [required]="isPhoneRequired" [(value)]="createUserDto.phoneVerifier.receiverId" [validate]="true"
    placeholder="Phone Number" label="Phone Number" type="phone"></super-input>

  <super-button sxMargin="10px 0 0" [action]="quickSignup" [showError]="true" iconEnd="chevron-forward-outline">
    Continue
  </super-button>

</div>
}

@if (activeSlide === slides.requiredContact) {
<div sxCol sxGap="10px" sxPadding="medium">
  @let rcUser = authenticatedUser$ | async;


  @if (isEmailRequired && !rcUser?.email) {

  <div class="p-2">
    <p class="m-0 text-lg text-gray-800">Add Email</p>
    <p class="m-0 text-sm text-gray-500">We will send a code to verify your email.</p>
  </div>

  <super-input [(value)]="createUserDto.emailVerifier.receiverId" [validate]="true" placeholder="youremail@example.com"
    type="email" iconStart="mail-outline"></super-input>
  }

  @if (isPhoneRequired && !rcUser?.phoneNumber) {
  <div class="p-2">
    <p class="m-0 text-lg text-gray-800">Add Phone Number</p>
    <p class="m-0 text-sm text-gray-500">We will send a code to verify your phone number.</p>
  </div>
  <super-input [(value)]="createUserDto.phoneVerifier.receiverId" [validate]="true" placeholder="Phone Number"
    type="phone" [showCountrySelector]="true"></super-input>
  }

  <super-button sxMargin="10px 0 0" [action]="completeRequiredContactAndContinue" [showError]="true"
    iconEnd="chevron-forward-outline">
    Continue
  </super-button>
</div>
}

@if (activeSlide == slides.accountFound) {
<div sxPadding="medium">

  <div sxCol sxCenterize="col" sxBackground="light" sxRadius="medium" sxPadding="medium">

    <p sxTextWeight="bold">Existing account found</p>
    <avatar-round [imageUrl]="existingAccount.displayPictureUrl" [title]="existingAccount.name"
      [size]="60"></avatar-round>
    <h1 class="name-container account-name" sxMargin="5px" sxTextSize="20px">{{existingAccount.name}}</h1>
    <p sxTextSize="16px" sxMargin="2px 0">{{existingAccount.email}}</p>
    <p sxTextSize="16px" sxMargin="2px 0">{{existingAccount.phoneNumber}}</p>
    <div sxCol sxWidth="full" sxGap="5px">
      <p sxColor="two" sxTextAlign="center">Log in to this account</p>
      @if (existingAccount.email) {
      <super-button type="outline" textAlign="start" iconEnd="chevron-forward-outline"
        [action]="onExistingEmailOtpClicked">
        Email OTP
      </super-button>
      }
      @if (existingAccount.phoneNumber) {
      <super-button type="outline" textAlign="start" [action]="onExistingPhoneOtpClicked"
        iconEnd="chevron-forward-outline">Phone OTP
      </super-button>
      }
    </div>

    <p sxColor="two">OR</p>
    <super-button sxWidth="full" type="outline" textAlign="start" iconEnd="chevron-forward-outline"
      (click)="useOtherAccount()">Use different
      account
    </super-button>
  </div>

</div>
}